module.exports = __webpack_public_path__ + "img/619-42dfb3.png";